/**
 * This function takes 6 arguments based on:
 * YEAR, MONTH, DAY, HOUR, MINUTE, SECOND.
 * The hour, minute and second parameters default
 * to 0 (zero) when non provided.
 * and turn them into a Date Object.
 * @param  {...any} args
 */
function dateFromArgs(year, month, day, hour = 0, minute = 0, second = 0) {
  const intYear = parseInt(year, 10);
  const intMonth = parseInt(month, 10) - 1; // Due to month is zero based
  const intDay = parseInt(day, 10);
  const intHour = parseInt(hour, 10);
  const intMinute = parseInt(minute, 10);
  const intSecond = parseInt(second, 10);
  return new Date(Date.UTC(intYear, intMonth, intDay, intHour, intMinute, intSecond));
}

export default dateFromArgs;
